import React from 'react';
import { Box, Container, Heading, Text, Image, VStack, HStack, Button, useToast, Card, CardBody } from '@chakra-ui/react';

const Logos = () => {
  const toast = useToast();
  const baseUrl = window.location.origin;

  const logos = [
    {
      name: 'Logo Header',
      path: '/logo/logo_mini.png',
      description: 'Logo original do cabeçalho'
    },
    {
      name: 'Logo Footer (Usado no Header)',
      path: '/logo/logo_day.png',
      description: 'Logo do rodapé - atualmente usado no cabeçalho'
    }
  ];

  const copyToClipboard = (url) => {
    navigator.clipboard.writeText(url);
    toast({
      title: 'Link copiado!',
      description: 'O link foi copiado para a área de transferência.',
      status: 'success',
      duration: 2000,
      isClosable: true,
    });
  };

  return (
    <Container maxW="container.xl" py={8}>
      <VStack spacing={8} align="stretch">
        <Box textAlign="center">
          <Heading as="h1" size="xl" mb={4}>
            Logos MICA Capital
          </Heading>
          <Text fontSize="lg" color="gray.600">
            Acesse e copie os links diretos para os logos da empresa
          </Text>
        </Box>

        <VStack spacing={6}>
          {logos.map((logo, index) => (
            <Card key={index} width="100%" variant="outline">
              <CardBody>
                <VStack spacing={4}>
                  <Heading as="h3" size="md">
                    {logo.name}
                  </Heading>
                  <Text color="gray.600">{logo.description}</Text>
                  
                  <Box 
                    p={6} 
                    bg="gray.50" 
                    borderRadius="lg" 
                    border="1px solid" 
                    borderColor="gray.200"
                    width="100%"
                    display="flex"
                    justifyContent="center"
                  >
                    <Image 
                      src={logo.path} 
                      alt={logo.name}
                      maxH="150px"
                      objectFit="contain"
                    />
                  </Box>

                  <VStack spacing={2} width="100%">
                    <Text fontWeight="bold">URL Direta:</Text>
                    <Box 
                      p={3} 
                      bg="gray.100" 
                      borderRadius="md" 
                      width="100%"
                      fontFamily="mono"
                      fontSize="sm"
                      wordBreak="break-all"
                    >
                      {baseUrl}{logo.path}
                    </Box>
                    
                    <HStack spacing={3}>
                      <Button 
                        colorScheme="blue" 
                        size="sm"
                        onClick={() => copyToClipboard(baseUrl + logo.path)}
                      >
                        Copiar Link
                      </Button>
                      <Button 
                        as="a"
                        href={logo.path}
                        target="_blank"
                        colorScheme="black" 
                        size="sm"
                      >
                        Abrir em Nova Aba
                      </Button>
                      <Button 
                        as="a"
                        href={logo.path}
                        download
                        colorScheme="purple" 
                        size="sm"
                      >
                        Baixar Logo
                      </Button>
                    </HStack>
                  </VStack>
                </VStack>
              </CardBody>
            </Card>
          ))}
        </VStack>

        <Box textAlign="center" mt={8} p={4} bg="blue.50" borderRadius="lg">
          <Text fontWeight="bold" mb={2}>Como usar os logos:</Text>
          <Text fontSize="sm" color="gray.700">
            1. Copie o link direto para usar em documentos ou sites externos<br/>
            2. Use o caminho relativo {`"/logo/nome_do_arquivo.png"`} em componentes React<br/>
            3. Os arquivos estão na pasta {`"frontend/public/logo/"`}
          </Text>
        </Box>
      </VStack>
    </Container>
  );
};

export default Logos;